import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IconNames } from '../../common/constants/icon-names';

@Component({
  selector: 'ui-validation-error-list',
  templateUrl: './validation-error-list.component.html',
  styleUrls: ['./validation-error-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationErrorListComponent implements OnChanges {
  @Input() invalidControls: (string | string[])[] = [];
  arrayIndex = 0;
  iconNames = IconNames;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.invalidControls) {
      this.arrayIndex = 0;
    }
  }

  isString(item: string | string[]): boolean {
    return typeof item === 'string';
  }

  isItemArray(item: string | string[]): boolean {
    const isArray = Array.isArray(item);
    isArray ? (this.arrayIndex += 1) : this.arrayIndex;
    return isArray;
  }
}
